import { combineReducers } from 'redux';

import * as actionTypes from 'modules/interventions/actionTypes';

import reducer from '../../../global/reducers/generic.loading';

export default combineReducers({
  isLoading: reducer(actionTypes.GET_WORKS_ORDER_BY_REPARATION_ORDER),
  error: reducer(actionTypes.GET_WORKS_ORDER_BY_REPARATION_ORDER),
});
